import { createSelector } from 'reselect'

const getUserData = state => state.user

const getStartedAdminOnboarding = createSelector(
	[getUserData],
	user => ({
		name: user.data?user.data.firstName:'',
		id: user.data?user.data.userId:0,
	})
)

export default getStartedAdminOnboarding
